import {Dispatch} from "redux";
import {Action} from "redux-actions";
import {ISelectValue} from "../common/Select.component";
import {PortfolioTab} from "./PortfolioPage";
import {PerformanceType} from "./portfolioUtil";

export enum PortfolioActions {
    SET_CURRENT_TAB = "SET_CURRENT_TAB",
    SET_ASSET_ALLOCATION_SELECTED_DATE = "SET_ASSET_ALLOCATION_SELECTED_DATE",
    UPDATE_ASSET_ALLOCATION_EXPANDED_ROWS = "UPDATE_ASSET_ALLOCATION_EXPANDED_ROWS",
    SET_ASSET_ALLOCATION_SELECTED_PRODUCT = "SET_ASSET_ALLOCATION_SELECTED_PRODUCT",
    SET_PERFORMANCE_SELECTED_DATE = "SET_PERFORMANCE_SELECTED_DATE",
    UPDATE_PERFORMANCE_EXPANDED_ROWS = "UPDATE_PERFORMANCE_EXPANDED_ROWS",
    SET_PERFORMANCE_SELECTED_PRODUCT = "SET_PERFORMANCE_SELECTED_PRODUCT",
    SET_PERFORMANCE_TYPE = "SET_PERFORMANCE_TYPE",
}

export const updateAssetAllocationExpandedRowsAction = (payload: number[]) => {
    return (dispatch: Dispatch<Action<number[]>>) => {
       dispatch ({type: PortfolioActions.UPDATE_ASSET_ALLOCATION_EXPANDED_ROWS, payload});
    };
};

export const setAssetAllocationDateAction = (payload: ISelectValue) => {
    return (dispatch: Dispatch<Action<ISelectValue>>) => {
        dispatch ({type: PortfolioActions.SET_ASSET_ALLOCATION_SELECTED_DATE, payload});
    };
};

export const setAssetAllocationSelectedProductAction = (payload: number) => {
    return (dispatch: Dispatch<Action<number>>) => {
        dispatch ({type: PortfolioActions.SET_ASSET_ALLOCATION_SELECTED_PRODUCT, payload});
    };
};

export const setCurrentTabAction = (payload: PortfolioTab) => {
    return (dispatch: Dispatch<Action<PortfolioTab>>) => {
        dispatch ({type: PortfolioActions.SET_CURRENT_TAB, payload});
    };
};

export const updatePerformanceExpandedRowsAction = (payload: number[]) => {
    return (dispatch: Dispatch<Action<number[]>>) => {
        dispatch ({type: PortfolioActions.UPDATE_PERFORMANCE_EXPANDED_ROWS, payload});
    };
};

export const setPerformanceDateAction = (payload: ISelectValue) => {
    return (dispatch: Dispatch<Action<ISelectValue>>) => {
        dispatch ({type: PortfolioActions.SET_PERFORMANCE_SELECTED_DATE, payload});
    };
};

export const setPerformanceSelectedProductAction = (payload: number) => {
    return (dispatch: Dispatch<Action<number>>) => {
        dispatch ({type: PortfolioActions.SET_PERFORMANCE_SELECTED_PRODUCT, payload});
    };
};

export const setPerformanceTypeAction = (payload: PerformanceType) => {
    return (dispatch: Dispatch<Action<PerformanceType>>) => {
        dispatch ({type: PortfolioActions.SET_PERFORMANCE_TYPE, payload});
    };
};